/* eslint-disable */
export default {
  hide: 'Piilota',
  end: 'Lopeta',
  keypad: 'Näppäimistö',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
